export const MIN_PASSWORD_LENGTH = 8;

// 회원가입 비밀번호 실시간 검사 규칙. 위에서부터 순서대로 화면에 나열한다.
export const PASSWORD_RULES = [
  { key: "length", label: `${MIN_PASSWORD_LENGTH}자 이상`, test: (v: string) => v.length >= MIN_PASSWORD_LENGTH },
  { key: "letter", label: "영문 포함", test: (v: string) => /[a-zA-Z]/.test(v) },
  { key: "number", label: "숫자 포함", test: (v: string) => /[0-9]/.test(v) },
  {
    key: "special",
    label: "특수문자 포함 (!@#$%^&* 등)",
    test: (v: string) => /[!@#$%^&*()\-_=+[\]{};:'",.<>/?\\|`~]/.test(v),
  },
] as const;

export function checkPasswordRules(password: string) {
  return PASSWORD_RULES.map((rule) => ({ label: rule.label, passed: rule.test(password) }));
}

export function isPasswordValid(password: string): boolean {
  return PASSWORD_RULES.every((rule) => rule.test(password));
}
